import { render, staticRenderFns } from "./showDataPage.vue?vue&type=template&id=ec3522e4&scoped=true"
import script from "./showDataPage.vue?vue&type=script&lang=js"
export * from "./showDataPage.vue?vue&type=script&lang=js"
import style0 from "./showDataPage.vue?vue&type=style&index=0&id=ec3522e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3522e4",
  null
  
)

export default component.exports